<template>
    <div>
        <div class="orderSummaryButton" @click="openSummaryModal">
            <div class="orderSummaryButton__icon__container">
                <img class="orderSummaryButton__icon" src='@/assets/images/decoration/link-icon-van.svg'>
            </div>
            <h4 class="orderSummaryButton__text">{{$t('SHOP_NAV_ORDERS')}}</h4>
        </div>
    </div>
</template>

<script>
import { turnScrollOff } from '@/helpers/ScrollHelpers.js';

export default {
    name: 'OrderSummaryButton',
    methods: {
        openSummaryModal() {
            this.$store.commit('shop/openOrderSummary');
            turnScrollOff(document);
        },
    },
};
</script>
